module.exports = __webpack_public_path__ + "img/otp.7c58f66c.png";